// The words the offer line needs (unify-ui ship 3, second fold, plan change 6): each offered language's own line, in
// that language, and the English page's dismiss label — read from the five shared tables, the one source. A tool page
// bundles the tables anyway (its strings compose them); the hub's script would carry all five for these few strings,
// so its build (esbuild.config.js, plugin `offer-words`) puts this object, computed here, in place of this module.
import { SHARED_EN } from './strings/en.js';
import { SHARED_TH } from './strings/th.js';
import { SHARED_JA } from './strings/ja.js';
import { SHARED_ZH_CN } from './strings/zh-cn.js';
import { SHARED_ZH_TW } from './strings/zh-tw.js';

export const OFFER_WORDS = {
  lines: { th: SHARED_TH.offerLine, ja: SHARED_JA.offerLine, 'zh-cn': SHARED_ZH_CN.offerLine, 'zh-tw': SHARED_ZH_TW.offerLine },
  dismiss: SHARED_EN.offerDismiss,
};
